import React from 'react';
import './assets-filters.scss';
import { UiInput, DataPicker } from '@ru-digital-assets/ui-component';
import { SearchIcon } from 'assets/icons';
import AppCheckbox from 'modules/app-checkbox/app-checkbox';
import { debounce } from 'lodash';

interface IAssetsFilters {
  onSearchTermChange: (term: string) => void;
  onPeriodChange: (range: { start: Date | null; end: Date | null }) => void;
  period: {
    from: Date | null;
    to: Date | null;
  };
  onIncludeReddemChange: (value: boolean) => void;
  includeReddem: boolean;
}

export default function AssetsFilters({
  onSearchTermChange,
  onPeriodChange,
  period,
  onIncludeReddemChange,
  includeReddem,
}: IAssetsFilters) {
  const onSearchChange = debounce((e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchTermChange(e.target.value);
  }, 300);

  return (
    <div className="assets-filters">
      <div className="mr_16" style={{ minWidth: '450px' }}>
        <UiInput
          label="Наименование актива или эмитент"
          sm
          leftIcon={<SearchIcon color="#444" />}
          onChange={onSearchChange}
        />
      </div>
      <div className="mr_16">
        <DataPicker
          label="Период выпуска"
          type="date"
          sm
          onPeriodChange={onPeriodChange}
          period={period}
        />
      </div>
      <div className="mr_16">
        <AppCheckbox
          sm
          checked={includeReddem}
          onChangeValue={onIncludeReddemChange}
          title="Показывать погашенные токены"
        />
      </div>
    </div>
  );
}
